import React from "react";
//#region types
import { PrintStandardBalanceReportProps } from "models/propTypes/accountingPropTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModelFinancialReport } from "wint-api-client/dist/types";
//#endregion
//#region components
import { NestedTablePrint } from "components/common";
import useFinancialReportRow from "../../././hooks/useFinancialReportRow";
//#endregion
import { DateHelper, LocalizationHelperInstance, FinancialReportHelper } from "utils/helpers";
import nestedTableStyles from "theme/custom/nestedTablePdf";

const PrintStandardBalanceReport: React.FC<PrintStandardBalanceReportProps> = (props) => {
  const { title, subtitle, getRange, result, ibHeaderDescription, ubHeaderDescription, showAccountNumber } = props;

  const { descriptionFormatter } = useFinancialReportRow(showAccountNumber);

  return (
    <NestedTablePrint<
      WintSuperkollAPIModelFinancialReport.FinancialReportRow,
      WintSuperkollAPIModelFinancialReport.FinancialReportRowColumn
    >
      title={title}
      subTitle={subtitle}
      rows={result}
      properties={{
        description: {
          description: TranslationKeys.Common.Name,
          formatter: descriptionFormatter,
        },
      }}
      repeatProperties={{
        key: "columns",
        properties: {
          iB: {
            description: ibHeaderDescription,
            formatter: (row: WintSuperkollAPIModelFinancialReport.FinancialReportRowColumn) =>
              LocalizationHelperInstance.getFormattedCurrency(row.iB ?? 0, undefined, 0, 0),
            alignment: "right",
            styles: nestedTableStyles.repeatCellSecondary,
          },
          amount: {
            description: TranslationKeys.Common.Amount,
            formatter: (row: WintSuperkollAPIModelFinancialReport.FinancialReportRowColumn) =>
              LocalizationHelperInstance.getFormattedCurrency(row.amount ?? 0, undefined, 0, 0),
            alignment: "right",
            styles: nestedTableStyles.repeatCellMain,
          },
          difference: {
            description: ubHeaderDescription,
            formatter: (row: WintSuperkollAPIModelFinancialReport.FinancialReportRowColumn) =>
              LocalizationHelperInstance.getFormattedCurrency(row.uB ?? 0, undefined, 0, 0),
            alignment: "right",
            styles: nestedTableStyles.repeatCellSecondary,
          },
        },
        filterField: (repeatIndex: number) => {
          const range = getRange(repeatIndex);
          return range ? DateHelper.formatMonthRange(range?.start, range?.end) : "";
        },
      }}
      childrenKey="children"
      rowDisplayType={FinancialReportHelper.getBalanceReportRowDisplayType}
    />
  );
};

export default PrintStandardBalanceReport;
